export enum MaintenanceEnum {
  FullLockdown = 'fullLockdown',
  Operational = 'operational',
  MaintenanceBanner = 'maintenanceBanner',
  GlobalMaintenanceBanner = 'globalMaintenanceBanner',
  SecuredMaintenanceBanner = 'securedMaintenanceBanner',
}
